<template>
  <section class="mt-4">
    <div v-if="data && data.length" v-click-outside="handleOutside">
      <div
        v-for="(d, i) in data"
        :key="i"
        class="mt-4 ring-1 ring-gray-200 px-4 py-3 rounded"
      >
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <Avatar :src="baseUrlSrc(d.thumbnail_url)" classStr="h-8 w-8" />
            <div class="ml-3">
              <div class="capitalize text-xl text-gray-dark">
                {{ d.name }}
              </div>
              <div class="-mt-1"><Rating :data="d.rating" /></div>
            </div>
          </div>
          <div class="relative" v-if="getToken() && d.reviewer_id != user.id">
            <button type="button" @click="toggleDotsVertical(d.id)">
              <DotsVertical />
            </button>
            <div v-click-outside="handleOutside" :data-index="`${i}`">
              <ReportDropdown
                v-model="isReportOpen[d.id]"
                :cat_item_id="d.id"
                :category_id="REVIEWS"
              />
            </div>
          </div>
        </div>
        <p class="mt-4 text-gray-700 text-xs">
          {{ d.body }}
        </p>
        <div class="flex items-center mt-2">
          <button
            v-if="getToken()"
            type="button"
            @click="$emit('review_id', d.id)"
            class="text-xs focus:outline-none text-gray-dark"
          >
            <div v-if="d.is_liked">
              <HeartFill />
            </div>
            <div v-else>
              <Heart />
            </div>
          </button>

          <button
            v-else
            type="button"
            class="text-xs focus:outline-none text-gray-dark"
          >
            <div>
              <Heart />
            </div>
          </button>

          <small class="ml-1 text-xs text-gray-dark"
            >{{ d.like_counter }}
          </small>
          <span class="text-xs text-gray-800 ml-1"
            >People found this helpful</span
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Avatar, Rating } from "@/components/t-components";
import { DotsVertical, Heart, HeartFill } from "@/components/icons";
import ReportDropdown from "@/components/report/ReportDropdown";
import ClickOutside from "vue-click-outside";

export default {
  components: {
    Avatar,
    Heart,
    HeartFill,
    Rating,
    DotsVertical,
    ReportDropdown,
  },
  props: {
    data: {
      type: Array,
    },
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      isReportOpen: [],
      REVIEWS: 2,
    };
  },
  methods: {
    toggleDotsVertical(id) {
      var obj = {};
      obj[id] = !this.isReportOpen[id];
      this.isReportOpen = obj;
    },

    handleOutside() {
      this.isReportOpen = false;
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>